import React from 'react';
import Skeleton from 'components/Common/Skeleton';
import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';

import { useGoal } from './useGoal';
import GoalCard from './GoalCard';
import useAutoStartScoreImprovementPlan from './useAutoStartScoreImprovementPlan';

import styles from './GoalsSection.module.scss';

export const AI_COACH_CHANGE_GOAL_EVENT = 'ai_coach_change_goal';

const GoalCardSkeleton = () => (
  <ActionCard variant={ActionCardVariant.White}>
    <div className={styles.skeletonCardContent}>
      <Skeleton width="180px" height="22px" mb="24px" />
      <div className={styles.skeletonProgressSection}>
        <Skeleton width="120px" height="120px" borderRadius="50%" />
        <div className={styles.skeletonAmountSection}>
          <Skeleton width="150px" height="32px" mb="8px" />
          <Skeleton width="120px" height="20px" mb="12px" />
          <Skeleton width="140px" height="24px" />
        </div>
      </div>
      <Skeleton width="100%" height="1px" my="16px" />
      <Skeleton width="160px" height="20px" />
    </div>
  </ActionCard>
);

const GoalsSection: React.FC = () => {
  const { goal, isError, isLoading, isLoadingNextSteps } = useGoal();
  useAutoStartScoreImprovementPlan();

  if (isError || (!goal && !isLoading)) return null;

  const showSkeleton = isLoading && !goal;

  return (
    <div className={styles.goalsSection}>
      {showSkeleton && <GoalCardSkeleton />}
      {goal && <GoalCard goal={goal} isLoadingActions={isLoadingNextSteps} />}
    </div>
  );
};

export default GoalsSection;
